import type { SVGProps } from 'react'
const SvgSyAddUser = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M9.877 14.457c-1.96 0-3.795.133-5.244.62-.725.242-1.364.577-1.85 1.081S2 17.357 2 18.115c0 .757.294 1.45.777 1.957s1.122.846 1.846 1.092c1.448.492 3.283.63 5.254.63 1.96 0 3.795-.134 5.244-.62.725-.243 1.364-.576 1.85-1.08s.783-1.2.783-1.957a2.83 2.83 0 0 0-.777-1.957c-.484-.507-1.122-.846-1.846-1.092-1.447-.492-3.283-.631-5.254-.631m0 1.5c1.893 0 3.622.16 4.771.55.575.196.993.447 1.243.708.249.261.363.515.363.922 0 .405-.114.656-.363.916-.25.26-.672.506-1.248.699-1.153.387-2.881.543-4.766.543-1.893 0-3.622-.16-4.772-.55-.575-.196-.992-.447-1.242-.708-.249-.261-.363-.515-.363-.922 0-.405.113-.656.363-.916s.67-.508 1.246-.701c1.154-.387 2.884-.541 4.768-.541"
				clipRule="evenodd"
			/>
			<path
				fillRule="evenodd"
				d="M9.877 2a5.33 5.33 0 0 0-5.316 5.314v.004a5.314 5.314 0 0 0 5.283 5.319h.033a5.33 5.33 0 0 0 5.318-5.319A5.33 5.33 0 0 0 9.877 2m0 1.5c2.118 0 3.818 1.7 3.818 3.818s-1.7 3.819-3.818 3.819h-.031A3.79 3.79 0 0 1 6.06 7.32v-.002c0-2.117 1.7-3.818 3.816-3.818"
				clipRule="evenodd"
				opacity={0.4}
			/>
			<path d="M19.203 7.92a.75.75 0 0 0-.75.75v4.01a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V8.67a.75.75 0 0 0-.75-.75" />
			<path d="M17.16 9.924a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h4.09a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z" />
		</g>
	</svg>
)
export default SvgSyAddUser
